var theBooks = [
{Title: "Retribution, a Corsican Vendetta Story [and other tales]",
Author: "Tonelli, Philippe",
Shelfmark: "British Library HMNTS 012621.ee.22.",
Page: "288",
Place: "London",
Year: "1897",
Publisher: "Dean & Son",
Edition: "[Another edition.]",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003652827",
Identifier: "003652827"},
{Title: "Das republikanische Brasilien in Vergangenheit und Gegenwart, etc. [With illustrations and maps.]",
Author: "Canstatt, Oscar",
Shelfmark: "British Library HMNTS 010480.g.4.",
Page: "87",
Place: "Leipzig",
Year: "1899",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000596236",
Identifier: "000596236"},
{Title: "Narrative of the Wreck of the Favourite on the Island of Desolation: detailing the adventures, sufferings and privations of J. Nunn, an historical account of the Island, and its whale and seal fisheries. Edited by W. B. Clarke",
Author: "Nunn, John -of Harwich",
Contributors: "Clarke, William Barnard",
Shelfmark: "British Library HMNTS 10460.e.23.",
Page: "209",
Place: "London",
Year: "1850",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002683469",
Identifier: "002683469"},
{Title: "The Sportsman and Naturalist in Canada, or notes on the Natural History of the Game, Game Birds, and Fish of that Country ... Illustrated with coloured plates and woodcuts",
Author: "King, William Ross",
Shelfmark: "British Library HMNTS 10470.i.4.",
Pages: "351, 329, 365",
Place: "London",
Year: "1866",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001969364",
Identifier: "001969364"},
{Title: "Im lnnern Afrikas. Die Erforschung des Kassai wahrend de r Jahre 1883, 1884, und 1885. Von H. von Wissmann, L. Wolf, C. von Francois, Hans Mueller. Dritte Auflage. Mit ... Abbildungen und 3 Karten",
Author: "Wissmann, Hermann Wilhelm Leopold Ludwig von.",
Contributors: "Francois, Curt Carl von., Mueller, Hans -Lieutenant, Wolf, Ludwig -Koniglichsachsischer Stabsarzt",
Shelfmark: "British Library HMNTS 010096.ff.16.",
Page: "123",
Place: "Leipzig",
Year: "1891",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003957105",
Identifier: "003957105"},
{Title: "Our New Alaska; or, the Seward purchase vindicated ... Illustrated, etc",
Author: "Hallock, Charles",
Shelfmark: "British Library HMNTS 10409.cc.18.",
Page: "151",
Place: "New York",
Year: "1886",
Publisher: "Forest and Stream Publishing Co.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001574535",
Identifier: "001574535"},
{Title: "Narrative of the Arctic Land Expedition to the mouth of the Great Fish River, and along the shores of the Arctic Ocean, in the years 1833, 1834, and 1835 ... Illustrated by a map and plates",
Author: "Back, George -Sir",
Shelfmark: "British Library HMNTS 792.e.4., British Library Oc Orw.1986.a.3078",
Pages: "561, 565",
Place: "London",
Year: "1836",
Publisher: "John Murray",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000163223",
Identifier: "000163223"},
{Title: "The Land of the Broads ... Illustrated edition.",
Author: "Suffling, Ernest Richard",
Shelfmark: "British Library HMNTS 10352.c.48.",
Pages: "307, 312, 309, 320, 325, 314",
Place: "Stratford",
Year: "1892",
Publisher: "B. Perry",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003538940",
Identifier: "003538940"},
{Title: "The Georgian Bay: an account of its position, inhabitants, mineral interests, fish, timber and other resources. With map and illustrations, etc",
Author: "Hamilton, James Cleland",
Shelfmark: "British Library HMNTS 10470.ee.25.",
Page: "125",
Place: "Toronto",
Year: "1893",
Publisher: "Carswell Co.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001579685",
Identifier: "001579685"},
{Title: "History of Chester County, Pennsylvania, with genealogical and biographical sketches ",
Author: "Futhey, John Smith -and Cope (Gilbert)",
Contributors: "Cope, Gilbert",
Shelfmark: "British Library HMNTS 10408.k.6.",
Page: "621",
Place: "Philadelphia",
Year: "1881",
Publisher: "L. H. Everts",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001344332",
Identifier: "001344332"},
{Title: "Outlines of Geology ... Second edition revised, etc",
Author: "Geikie, James ",
Shelfmark: "British Library HMNTS 7109.e.13.",
Page: "399",
Place: "London",
Year: "1883",
Publisher: "Edward Stanford",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001384295",
Identifier: "001384295"},
{Title: "A Manual of Elementary Geology .... Third and entirely revised edition.",
Author: "Lyell, Charles -Sir, Bart",
Shelfmark: "British Library HMNTS 7108.bb.37.(1.)",
Page: "151",
Place: "London",
Year: "1855",
Publisher: "J. Murray Edition : Fifth edition ... enlarged, etc.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002293121",
Identifier: "002293121"},
{Title: "The Countries of the World: being a popular description of the various continents, islands, rivers, seas, and peoples of the globe. [With plates.]",
Author: "Brown, Robert -M.A., Ph.D",
Shelfmark: "British Library HMNTS 10006.ff.1. ",
Volume: "02",
Page: "218",
Place: "London",
Year: "1876",
Publisher: "Cassell, Petter & Galpin",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000495545",
Identifier: "000495545"},
{Title: "Acadian Geology: an account of the geo logical structure and mineral resources of Nova Scotia, and portions of the neighbouring provinces of British America. [With maps.]",
Author: "Dawson, John William -Sir",
Shelfmark: "British Library HMNTS 07108.i.47.",
Page: "335",
Place: "London",
Year: "1868",
Publisher: "Macmillan & Co.",
Edition: "Second edition, revised and enlarged. With a geological map and numerous illustrations.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000883102",
Identifier: "000883102"},
{Title: "Narrative of a Journey in the Interior of China, and of a voyage to and from that country, in the years 1816 and 1817; containing an account of the most interesting transactions of Lord Amherst's Embassy to the Court of Pekin, etc. [With plates and maps.]",
Author: "Abel, Clarke",
Shelfmark: "British Library HMNTS 981.f.17., British Library HMNTS 146.f.16., British Library OC V 8820",
Page: "33",
Place: "London",
Year: "1818",
Publisher: "Longman & Co.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000005645",
Identifier: "000005645"},
{Title: "The British Miscellany: or, coloured figures of new, rare, or little known animal subjects, etc. vol. I.,vol. Ii",
Author: "Sowerby, James",
Shelfmark: "British Library HMNTS 990.i.3. ",
Pages: "305, 319, 207, 309, 313, 189, 301, 307, 285, 283, 209, 293, 205, 315, 211",
Place: "London",
Year: "1806",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003450253",
Identifier: "003450253"},
{Title: "The World before the Deluge ... Containing twenty-five ideal landscapes of the ancient world, designed by Riou, and two hundred and eight figures of animals, plants [with illustrative text] ... Translated from the fourth French edition [by W. S. O.]",
Author: "Figuier, Guillaume Louis.",
Contributors: "Bristow, Henry William., Riou, Edouard",
Shelfmark: "British Library HMNTS 07107.h.28.",
Page: "337",
Place: "London",
Year: "1867",
Edition: "New edition . The geological portion carefully revised, and much original matter added, by H. W. Bristow. Containing ... illustrations ... by Riou, etc .",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum001232583",
Identifier: "001232583"},
{Title: "The Moor and the Loch: containing practical hints on most of the Highland sports, and notices of the habits of the different creatures of game and prey in the mountainous districts of Scotland; with an essay on loch-fishing. [With plates.]",
Author: "Colquhoun, John - Author of The Moor and the Loch",
Shelfmark: "British Library HMNTS 808.ff.5.",
Page: "101",
Place: "Edinburgh",
Year: "1840",
Publisher: "William Blackwood & Sons",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000753551",
Identifier: "000753551"},
{Title: "La Terra, trattato popolare di geografia universale per G. Marinelli ed altri scienziati italiani, etc. [With illustrations and maps.]",
Author: "Marinelli,Giovanni - Professor of Geography at Padua",
Shelfmark: "British Library HMNTS 10006.h .10. ",
Volume: "08",
Page: "1047",
Place: "Milano",
Year: "1898",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002383118",
Identifier: "002383118"},
{Title: "Jottings during the Cruise of H.M.S. Curacoa among the South Sea Islands in 1865 ... With ... natural history notices [by G. R. Gray, A. C. L. G. Guenther and others ]. [With plates and a map.]",
Author: "Brenchley, Julius Lucius",
Shelfmark: "British Library HMNTS 10491.g.36.",
Page: "533",
Place: "London",
Year: "1873",
Publisher: "Longmans & Co.",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum000464272",
Identifier: "000464272"},
{Title: "Journal of a Voyage to Greenland, in the year 1821. With graph illustrations",
Author: "Manby, George William",
Shelfmark: "British Library HMNTS 792.1.2.",
Page: "65",
Place: "London",
Year: "1822",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002360909",
Identifier: "002360909"},
{Title: "Text Book of Geology for schools and colleges ",
Author: "Nicholson, Henry Alleyne",
Shelfmark: "British Library HMNTS 7107.aa.30.",
Page: "184",
Place: "Toronto, New York",
Year: "1872",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002649825",
Identifier: "002649825"},
{Title: "Vegas Reise omk ring Asia og Europa ... Autoriseret Udgave for Norge og Danmark ved B. Geelmuyden, etc",
Author: "Nordenskiold, Nils Adolf Erik -Baron",
Contributors: "Geelmuyden, B",
Shelfmark: "British Library HMNTS 10460.ff.17. ",
Volume: "01, 02",
Page: "194",
Place: "Kristiania",
Year: "1881",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002668467",
Identifier: "002668467"},
{Title: "The W.I.S.B",
Author: 'Unknown',
Shelfmark: "British Library HMNTS 1050.1.18,19. ",
Volume: "01",
Page: "117",
Place: "London",
Year: "1834",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003893652",
Identifier: "003893652"},
{Title: "My first voyage. A book for youth. Illustrated by E. Roffe",
Author: "Stones, William -Author of My First Voyage.",
Contributors: "Roffe, Edwin",
Shelfmark: "British Library HMNTS 12808.b.37., British Library HMNTS 10026 .c.19.",
Pages: "32, 34, 29",
Place: "London",
Year: "1858",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum003514983",
Identifier: "003514983"},
{Title: "The Zoological Miscellany; being descriptions of new or interesting animals ",
Author: "Leach, William Elford",
Shelfmark: "British Library HMNTS 990.k.8-10., British Library HMNTS 45.b.16. ",
Pages: "Volume 1: 215, 245, Volume 3: 177, 181, 185, 187",
Place: "London",
Year: "1814",
Flickr: "https://www.flickr.com/photos/britishlibrary/tags/sysnum002099152",
Identifier: "002099152"}
]

export default theBooks